export const CREATE_PROTRACK_FORM_NAME = 'createProtrack'
export const EDIT_PROTRACK_FORM_NAME = 'editProtrack'
export const RATING_PROTRACK_FORM = 'ratingProtrack'
export const PROTRACK_NAME_LENGTH = 20
